'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dragOver = exports.dragEnd = exports.dragStart = undefined;

var _draggingConstants = require('./draggingConstants');

var dragStart = exports.dragStart = function dragStart(ids) {
  return { type: _draggingConstants.DRAG_START, ids: ids };
};
var dragEnd = exports.dragEnd = function dragEnd() {
  return { type: _draggingConstants.DRAG_END };
};
var dragOver = exports.dragOver = function dragOver(targetId, targetType) {
  return { type: _draggingConstants.DRAG_OVER, targetId: targetId, targetType: targetType };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/draggingActions.js
// module id = 462
// module chunks = 0